import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { usePermissionDeniedStore } from '../stores/permission-denied.store';

const PermissionDeniedOverlay: React.FC = () => {
  const { open, message, hide } = usePermissionDeniedStore();

  return (
    <Dialog
      open={open}
      onClose={hide}
      maxWidth="xs"
      fullWidth
      aria-labelledby="permission-denied-title"
      slotProps={{
        backdrop: {
          sx: {
            backdropFilter: 'blur(8px)',
            backgroundColor: 'rgba(0, 0, 0, 0.45)',
          },
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: (theme) => theme.shadows[12],
        },
      }}
    >
      <DialogTitle id="permission-denied-title" sx={{ pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              bgcolor: 'error.light',
              color: 'error.contrastText',
            }}
          >
            <LockOutlinedIcon />
          </Box>
          <Typography variant="h6" component="span" fontWeight={600}>
            Permission denied
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="contained" onClick={hide} autoFocus>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PermissionDeniedOverlay;
